import React from "react";
import { FormControlLabel, Slider, Switch, Typography } from "@mui/material";
import { usePlayerActions } from "../../actions";
import type { ImagePanelWithInference } from "../../panels";
import { constraints, usePairedTopics } from "../../panels";

export function ImageResultsControls({
  panel,
}: {
  panel: ImagePanelWithInference;
}) {
  const [, { descriptor: topicDescriptor }] = usePairedTopics(panel);

  const playerActions = usePlayerActions();

  function handleOpacityChange(_: unknown, newOpacity: number | number[]) {
    playerActions.setInferenceImageOpacity(panel, newOpacity as number);
  }

  function handleInferenceImageColorizationToggle(
    e: React.ChangeEvent<HTMLInputElement>,
  ) {
    playerActions.toggleInferenceImageColorization(panel, e.target.checked);
  }

  return (
    <>
      <Typography>Opacity</Typography>
      <Slider
        sx={{
          alignSelf: "center",
          width: (theme) => `calc(100% - ${theme.spacing(2.5)})`,
        }}
        min={constraints.imageOpacityPct.min}
        max={constraints.imageOpacityPct.max}
        step={constraints.imageOpacityPct.step}
        value={topicDescriptor.opacity}
        onChange={handleOpacityChange}
      />
      <FormControlLabel
        sx={{ justifyContent: "space-between", ml: 0 }}
        control={
          <Switch
            checked={topicDescriptor.colorize}
            onChange={handleInferenceImageColorizationToggle}
          />
        }
        label="Colorize"
        labelPlacement="start"
      />
    </>
  );
}
